import { ProjectStatusMatrixBase } from './base/project-status-matrix-base';

export class ProjectStatusMatrix extends ProjectStatusMatrixBase { }